import { Outlet, useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PropTypes from 'prop-types';
import EveThemeProvider from '@ashn/eve-themes-react/EveThemeProvider';
import SideNavigation from '../SideNavigation/SideNavigation';
import useIsMobile from '../../../hooks/useIsMobile';

const hasNavItemsAndPermissions = (navItems, permissions) =>
	navItems &&
	navItems.length > 0 &&
	permissions &&
	Object.keys(permissions).length > 0;

const PageLayout = ({
	pageTitle,
	children,
	navItems,
	permissions,
	renderBackButton,
}) => {
	const isMobile = useIsMobile();
	const navigate = useNavigate();

	return (
		<EveThemeProvider themeKey='internal' themeMode='light'>
			<Container>
				{renderBackButton && (
					<Button
						onClick={() => navigate(-1)}
						variant='text'
						sx={{ px: 0, pt: 3 }}
					>
						<KeyboardArrowLeftIcon sx={{ ml: -1 }} /> Back
					</Button>
				)}
				<Typography
					variant={pageTitle === 'Manage Sub Accounts' ? 'h5' : 'h4'}
					component='h1'
					mb={2}
					pt={3}
				>
					{pageTitle}
				</Typography>
				<Divider sx={{ mb: 4 }} />
				<Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
					{!isMobile &&
						hasNavItemsAndPermissions(navItems, permissions) && (
							<Box
								component='nav'
								sx={{ width: '250px', flexShrink: 0 }}
							>
								<nav aria-label='Side Navigation'>
									<SideNavigation pages={navItems} />
								</nav>
							</Box>
						)}
					<Box component='section' sx={{ flex: 1, minWidth: 0 }}>
						{children}
						<Outlet />
					</Box>
				</Box>
			</Container>
		</EveThemeProvider>
	);
};

PageLayout.defaultProps = {
	children: undefined,
	navItems: [],
	permissions: {},
	renderBackButton: false,
};
export default PageLayout;

PageLayout.propTypes = {
	pageTitle: PropTypes.string.isRequired,
	children: PropTypes.node,
	navItems: PropTypes.array,
	permissions: PropTypes.object,
	renderBackButton: PropTypes.bool,
};
